export const swapQuestions = (questions, first, second) => {
  let questionsClone = questions.slice(0);
  const temp = questionsClone[first];

  questionsClone[first] = questionsClone[second];
  questionsClone[second] = temp;

  return questionsClone;
};
